import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import { defaultOrdersDispatchData, createOrdersDispatch, fetchPendingDispatch } from "@/api/orders-dispatches";
import { getDispatchProducts } from "@/api/order";
import { AppModule } from "@/store/modules/app";
import { TagsViewModule } from "@/store/modules/tags-view";
import { Action } from "vuex-module-decorators";
import FileUpload from "@/components/FileUpload/index.vue";
import router from "@/router";
import Inr from "@/components/Inr/index.vue";
import { getDealersTransporters } from "@/api/dealers-transporters";
import { getQuery } from "@/utils";
import { getAdmins } from "@/api/admins";
import { getUnits } from "@/api/locations/units";
import { AdminModule } from "@/store/modules/admin";
import { getDealerById, searchDealers } from "@/api/dealers";
import { getDealersAddresses } from "@/api/dealers-addresses";
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultOrdersDispatchData);
    this.loading = false;
    this.ordersProductsListLoading = false;
    this.order = null;
    this.ordersProductsDispatch = [];
    this.transporterList = [];
    this.quantityToBeDispatched = 0;
    this.quantityToSettle = 0;
    this.totalCartons = 0;
    this.tableKey = 0;
    this.unitManagers = [];
    this.unitList = [];
    this.dealerList = [];
    this.dealerLoading = false;
    this.dealerAddress = null;
    this.addressList = [];
    this.hasSeparateAddress = false;
    this.hasVehicleNumber = false;
    this.rules = {
      quantity: {
        required: true,
        trigger: "blur",
        message: "This field is required"
      },
      dealersTransporterId: {
        required: true,
        trigger: "blur",
        message: "This field is required"
      },
      adminId: {
        required: true,
        trigger: "blur",
        message: "This field is required"
      },
      unitId: {
        required: true,
        trigger: "blur",
        message: "This field is required"
      },
      dealerId: {
        required: true,
        trigger: "blur",
        message: "This field is required"
      },
      privateMarka: [{
        required: true,
        trigger: "blur",
        message: "This field is required"
      }, {
        min: 1,
        max: 20,
        message: "Length should be between 1 - 20",
        trigger: "blur"
      }],
      dispatchDate: {
        required: true,
        trigger: "blur",
        message: "This field is required"
      }
    };
    this.loggedInAdmin = null;
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    this.loggedInAdmin = AdminModule;
    this.formData = Object.assign({}, defaultOrdersDispatchData);
    this.tempTagView = Object.assign({}, this.$route);
    // set default dispatch date as current
    const currentDate = new Date();
    this.formData.dispatchDate = currentDate;
    // next tick
    this.$nextTick(() => {
      // get unit managers
      this.fetchUnitManagers();
      // get dealers
      // this.getDealerList();
      // do Add Operations
      this.doAddOperations();
    });
  }
  doAddOperations() {}
  async getPendingDispatch(orderId) {
    try {
      this.ordersProductsListLoading = true;
      const products = await getDispatchProducts(0);
      products.map(val => {
        val.outstandingQty = 0;
      });
      this.ordersProductsDispatch = products;
      this.ordersProductsListLoading = false;
    } catch (err) {
      this.ordersProductsListLoading = false;
    }
  }
  async getAddressList() {
    try {
      // get user address list
      this.addressList = await getDealersAddresses(getQuery({
        enabled: true,
        dealerId: this.formData.dealerId,
        sort: "name,ASC",
        filter: {
          enabled: "$eq",
          dealerId: "$eq"
        }
      }));
      // show default selected if length is 1
      if (this.addressList.length === 1) {
        this.formData.deliveryAddressId = this.addressList[0].id;
        this.formData.billingAddressId = this.addressList[0].id;
      }
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async fetchTransporterList(dealerId = 0) {
    // reset transporter ID
    this.formData.dealersTransporterId = null;
    // fetch dealers transporters
    this.transporterList = await getDealersTransporters(getQuery({
      enabled: true,
      dealerId,
      sort: "isPrimary,ASC",
      filter: {
        enabled: "$eq",
        dealerId: "$eq"
      }
    }));
    // if length is 1 show selected by default
    switch (this.transporterList.length) {
      case 0:
        this.formData.dealersTransporterId = null;
        break;
      case 1:
        this.formData.dealersTransporterId = this.transporterList[0].id;
        break;
      default:
        break;
    }
  }
  async fetchUnitManagers() {
    let managerUnitId;
    // if adding & logged in user is unit manager
    if (!this.isEdit && this.loggedInAdmin.roles.includes("Unit Manager")) {
      managerUnitId = this.loggedInAdmin.id;
      // set to form data
      this.formData.adminId = this.loggedInAdmin.id;
      // fetch units as per manager
      this.fetchUnitList();
    }
    // if editing, then get saved unit manager id
    if (this.isEdit) {
      managerUnitId = this.formData.adminId;
    }
    this.unitManagers = await getAdmins(getQuery({
      id: managerUnitId,
      enabled: true,
      adminsRoleId: 3,
      filter: {
        id: "$eq",
        enabled: "$eq",
        adminsRoleId: "$eq"
      }
    }));
  }
  async fetchUnitList() {
    try {
      // reset unit ID
      this.formData.unitId = null;
      this.resetFields();
      this.unitList = await getUnits(getQuery({
        enable: true,
        "admin.id": this.formData.adminId,
        sort: "name,ASC",
        filter: {
          enabled: "$eq",
          "admin.id": "$eq"
        }
      }));
      switch (this.unitList.length) {
        case 0:
          this.formData.unitId = null;
          break;
        case 1:
          this.formData.unitId = this.unitList[0].id;
          break;
        default:
          break;
      }
    } catch (err) {} // eslint-disable-line  no-empty
  }
  isDateAllowed(time) {
    return time.getTime() > Date.now();
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title}`;
  }
  quantityUpdated(row) {
    // update totalCartonCount at product level
    row.totalCartonCount = parseFloat((row.quantity / row.product.masterCarton).toFixed(2));
    // check if its positive quantity
    this.quantityToSettle = this.ordersProductsDispatch.reduce((prevQuantity, dispatch) => {
      return prevQuantity + +dispatch.quantity;
    }, 0 // initial value
    );
    if (this.quantityToSettle) {
      // calc total carton qty
      this.totalCartons = this.ordersProductsDispatch.reduce((prevQuantity, dispatch) => {
        return prevQuantity + +dispatch.totalCartonCount;
      }, 0 // initial value
      );
      // round up to nearest decimal
      this.totalCartons = parseFloat(this.totalCartons.toFixed(2));
    }
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        if (this.quantityToSettle > 0) {
          this.saveForm();
        } else {
          this.$notify({
            title: "Warning",
            message: "Please add at least 1 quantity to dispatch",
            type: "warning",
            duration: 2000
          });
          return false;
        }
      } else {
        return false;
      }
    });
  }
  async saveForm() {
    try {
      this.loading = true;
      // delete admin, dealer, agent, transporter object from formData if exists
      if (this.formData.admin) {
        delete this.formData.admin;
      }
      if (this.formData.dealer) {
        delete this.formData.dealer;
      }
      if (this.formData.agent) {
        delete this.formData.agent;
      }
      if (this.formData.dealersTransporter) {
        delete this.formData.dealersTransporter;
      }
      // format date
      this.formData.dispatchDate = this.$moment(this.formData.dispatchDate).format("YYYY-MM-DD");
      this.formData.unit = {
        id: this.formData.unitId
      };
      // assign total carton count
      this.formData.totalCartonCount = this.totalCartons;
      // assign ordersProductsDispatch to formData
      this.formData.ordersProductsDispatch = this.ordersProductsDispatch;
      // remove dispatch where quantity is 0
      this.formData.ordersProductsDispatch = this.formData.ordersProductsDispatch.filter(dispatch => {
        return dispatch.quantity > 0;
      });
      let response = {
        status: "info",
        message: "Try again!"
      };
      if (!this.isEdit) {
        response = await createOrdersDispatch(this.formData);
      }
      this.loading = false;
      this.$notify({
        title: response.status,
        message: response.message,
        type: response.status,
        duration: 2000
      });
      router.push("/orders-dispatches/list");
    } catch (err) {
      this.loading = false;
    }
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      this.loading = true;
      let selectedDealerId;
      if (this.isEdit) {
        selectedDealerId = this.formData.dealerId;
      } else {
        // search only if length is greater than 1
        if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
          this.dealerList = [];
          return;
        }
      }
      const searchParams = {
        keyword: query,
        searchBy: isNumeric ? "dealerId" : "name",
        branchId: AdminModule.branchIds,
        fromDispatch: true
      };
      this.dealerList = await searchDealers(searchParams);
    } catch (err) {
      this.dealerList = [];
    } finally {
      this.loading = false;
    }
  }
  async dealerOrUnitChanged() {
    try {
      this.resetFields();
      // show dealer address
      this.dealerAddress = null;
      if (this.formData.dealerId && this.dealerList.length) {
        this.dealerList.map(val => {
          if (val.id === this.formData.dealerId) {
            if (val.isDispatchSuspended) {
              this.$message({
                type: "warning",
                message: "Dispatch for this dealer has been temporarily suspended",
                duration: 3000
              });
              this.formData.dealerId = null;
              return false;
            }
            // check if address exist
            if (val.address.length) {
              const address = val.address.find(addr => addr.isPrimary === true);
              if (address) {
                this.dealerAddress = [address.name, address.line1, address.city.name, address.state.name].join(", ");
                // assign private marka of dealer
                this.formData.privateMarka = val.privateMarka;
              }
            }
            // break loop
            return false;
          }
        });
        // fetch mapped transporters
        if (this.formData.dealerId) {
          this.fetchTransporterList(this.formData.dealerId);
          const dealer = await getDealerById(this.formData.dealerId);
          if (dealer.hasSeparateAddress) {
            this.hasSeparateAddress = true;
            this.getAddressList();
          }
        }
      }
      // if not empty & adding new then get orders dispatch products & available qty
      if (!this.isEdit && this.formData.unitId && this.formData.dealerId) {
        const pendingDispatches = await fetchPendingDispatch({
          dealerId: this.formData.dealerId || 0,
          unitId: this.formData.unitId || 0
        });
        /**
         * ordersProductsDispatch
         * { id, productId, productName, productsVariationId, productsVariantName, quantityOrdered, quantityDispatched, quantityPending, quantityAvailable, looseCartonCount, standardCartonCount, totalCartonCount }
         */
        if (pendingDispatches) {
          // loop over pending dispatches & add to ordersProductsDispatch array
          pendingDispatches.forEach(dispatch => {
            this.ordersProductsDispatch.push({
              id: 0,
              productId: dispatch.product.id,
              product: dispatch.product,
              productsVariationId: dispatch.productsVariationId,
              productsVariation: dispatch.productsVariation,
              quantityOrdered: dispatch.quantityOrdered,
              quantityDispatched: dispatch.quantityDispatched,
              quantityPending: dispatch.quantityOrdered - dispatch.quantityDispatched,
              quantityAvailable: dispatch.quantityAvailable,
              quantity: 0,
              looseCartonCount: 0,
              standardCartonCount: 0,
              totalCartonCount: 0
            });
          });
        }
      }
    } catch (err) {
      console.trace(err);
      console.error(err);
    }
  }
  // reset dispatch item list, quantity to settle and carton count
  resetFields() {
    this.ordersProductsDispatch = [];
    this.quantityToSettle = 0;
    this.totalCartons = 0;
  }
  getFullAddress(address) {
    const addressArray = [];
    if (address.line1) {
      // replace () with [] if any
      const addressLine1 = address.line1.replace(/\(/g, "[").replace(/\)/g, "]");
      addressArray.push(addressLine1);
    }
    if (address.line2) {
      // replace () with [] if any
      const addressLine2 = address.line2.replace(/\(/g, "[").replace(/\)/g, "]");
      addressArray.push(addressLine2);
    }
    if (address.cityName) {
      addressArray.push(address.cityName);
    }
    if (address.state) {
      addressArray.push(address.state.name);
    }
    if (address.pincode) {
      addressArray.push(address.pincode.pincode);
    }
    return addressArray.join();
  }
  onTransporterChange(selectedId) {
    const selected = this.transporterList.find(t => t.id === selectedId);
    if (selected.transporter.vehicleNumber) {
      this.hasVehicleNumber = true;
      this.formData.vehicleNumber = selected.transporter.vehicleNumber;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: "OrdersDispatchDetail",
  components: {
    Inr,
    FileUpload
  }
})], default_1);
export default default_1;